class Monthly
{
	constructor()
	{
		this.input = document.getElementById('monthly-amount')
		this.button = document.getElementById('monthly-button')
		this.textFreedom = document.getElementById('monthly-freedom')
		this.textGift = document.getElementById('monthly-gift')

		this.amount = this.input.value

		this.setup()
		this.handle()
	}

	setup()
	{
		this.textGift.style.display = 'none'
	}

	switcher(value)
	{
		if (value >= 24)
		{
			this.textGift.style.display = 'none'
			this.textFreedom.style.display = 'block'
			this.button.classList.remove('btn--blue')
			this.button.classList.add('btn--orange')
		}

		if (value < 24)
		{
			this.textGift.style.display = 'block'
			this.textFreedom.style.display = 'none'
			this.button.classList.add('btn--blue')
			this.button.classList.remove('btn--orange')
		}
	}

	handle()
	{
		this.input.addEventListener('input', () =>
		{
			this.switcher(this.input.value)
		})
	}
}

export default class Donate
{
	constructor()
	{
		this._donate = document.querySelector(".jsDonate");

		this._donateSwitch = document.querySelector(".jsDonateSwitch");
		this._donateSubtract = document.querySelectorAll(".jsDonateSubtract");
		this._donateAdd = document.querySelectorAll(".jsDonateAdd");

		//helper
		this._step = 1;

		// check
		if (this._donate) this.init();
	}

	dispatch(element)
	{
		const event = document.createEvent('Event');
		event.initEvent('input', true, true)
		element.dispatchEvent(event)
	}

	addValue(i)
	{
		let input = i.parentElement.querySelector(".jsDonateValue");
		let newValue = parseInt(input.value) + this._step;

		input.value = newValue;
		this.dispatch(input)
	}

	subtractValue(i)
	{
		let input = i.parentElement.querySelector(".jsDonateValue");
		let newValue = parseInt(input.value) - this._step;

		if (newValue < 0) newValue = 0;

		input.value = newValue;
		this.dispatch(input)
	}

	changeColors(type) { }

	init()
	{
		const monthly = new Monthly

		let l = this._donateSubtract.length;

		for (let i = 0; i < l; i++)
		{
			let btn = this._donateSubtract[i];

			btn.addEventListener("click", (event) =>
			{
				event.preventDefault()
				this.subtractValue(btn);
			});
		}

		l = this._donateAdd.length;
		for (let i = 0; i < l; i++)
		{
			let btn = this._donateAdd[i];

			btn.addEventListener("click", (event) =>
			{
				event.preventDefault()
				this.addValue(btn);
			});
		}
	}
}
